
  var _styles = {
  "max-demo-title": {
    "fontFamily": "Arial",
    "fontSize": "1.2rem",
    "fontWeight": "bold",
    "padding": "1.06667rem",
    "display": "flex",
    "backgroundColor": "rgb(10,29,86)",
    "color": "rgb(253,231,103)"
  },
  "max-demo-desc": {
    "paddingTop": "0.53333rem",
    "paddingRight": "1.06667rem",
    "paddingBottom": "0.53333rem",
    "paddingLeft": "1.06667rem",
    "fontSize": "0.64rem",
    "backgroundColor": "rgb(201,215,221)",
    "color": "rgb(99,122,159)"
  },
  "block-flight-special-ticket-header": {
    "position": "relative",
    "overflow": "hidden",
    "width": "100%",
    "display": "flex"
  },
  "block-flight-special-container": {
    "position": "relative",
    "padding": "0.32rem",
    "width": "100%",
    "overflow": "hidden",
    "fontSize": "0.32rem",
    "backgroundColor": "rgb(107,68,0)"
  },
  "flight-special-ticket-container": {
    "position": "relative",
    "width": "100%",
    "fontSize": 0
  },
  "block-flight-special-ticket-header-img": {
    "width": "100%",
    "backgroundSize": "cover",
    "backgroundPosition": "center",
    "backgroundRepeat": "no-repeat"
  },
  "block-flight-special-container-flex": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center"
  },
  "block-flight-special-container-flex-title": {
    "flex": 1
  },
  "block-flight-special-container-negative-margin": {
    "marginTop": 0,
    "marginRight": "-0.32rem",
    "marginBottom": 0,
    "marginLeft": "-0.32rem"
  },
  "block-flight-special-container-title": {
    "position": "relative",
    "paddingTop": 0,
    "paddingRight": 0,
    "paddingBottom": "0.33333rem",
    "paddingLeft": "0.26667rem",
    "lineHeight": "0.61333rem",
    "fontSize": "0.42667rem",
    "color": "rgb(255,255,255)"
  },
  "block-flight-special-container-title-switch": {
    "fontSize": "0.34667rem"
  },
  "block-flight-special-container-title-title-left": {
    "width": "0.08rem",
    "height": "0.4rem"
  },
  "block-flight-special-container-theme-title": {
    "paddingTop": 0,
    "paddingRight": "0.24rem",
    "paddingBottom": 0,
    "paddingLeft": "0.24rem",
    "position": "relative",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "lineHeight": "0.6rem",
    "fontSize": "0.42667rem",
    "color": "rgba(0,0,0,0.84)",
    "fontFamily": "PingFangSC-Semibold"
  },
  "block-flight-special-container-theme-title-title-img": {
    "position": "absolute",
    "left": "0.13333rem",
    "top": 0,
    "width": "0.26667rem",
    "height": "0.26667rem"
  },
  "block-flight-special-container-theme-title-flex-switch": {
    "flexDirection": "row",
    "display": "flex",
    "zIndex": 1
  },
  "block-flight-special-container-theme-title-flex-switch-flex-switch-text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgba(0,0,0,0.6)",
    "lineHeight": "0.6rem"
  },
  "block-flight-special-container-theme-title-switch-img": {
    "marginLeft": "0.08rem",
    "marginTop": "0.10667rem",
    "width": "0.36rem",
    "height": "0.36rem"
  },
  "block-flight-special-container-card-pics": {
    "paddingTop": "0.13333rem",
    "paddingRight": 0,
    "paddingBottom": "0.13333rem",
    "paddingLeft": 0
  },
  "block-flight-special-container-card-pics-negative-margin": {
    "marginTop": 0,
    "marginRight": "-0.26667rem",
    "marginBottom": "0.26667rem",
    "marginLeft": "-0.26667rem"
  },
  "block-flight-special-container-card-pics-pic-item": {
    "lineHeight": 0,
    "fontSize": "0.32rem",
    "width": "4.58667rem",
    "marginBottom": "0.16rem"
  },
  "block-flight-special-container-pic-list": {
    "width": "100%",
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "justifyContent": "space-between"
  },
  "block-flight-special-container-bottomBtn": {
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "block-flight-special-container-foldBtn": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "paddingTop": "0.17333rem",
    "paddingRight": "0.32rem",
    "paddingBottom": "0.17333rem",
    "paddingLeft": "0.32rem"
  },
  "block-flight-special-container-foldBtnTitle": {
    "fontSize": "0.32rem",
    "color": "rgb(34,34,34)",
    "fontWeight": "400"
  },
  "block-flight-special-container-foldBtnArrow": {
    "marginTop": "-0.05333rem",
    "marginLeft": "0.04667rem",
    "width": "0.32rem",
    "height": "0.32rem"
  },
  "block-flight-special-container-rotate-img": {
    "marginTop": 0,
    "transform": "rotate(180deg)",
    "transformOrigin": "center"
  },
  "block-flight-special-container-bargin-title": {
    "fontSize": "0.4rem",
    "color": "rgb(255,255,255)",
    "lineHeight": "0.56rem",
    "marginBottom": "0.26667rem",
    "marginLeft": "0.13333rem",
    "fontWeight": "100",
    "position": "relative",
    "position:before": "absolute",
    "width:before": "0.05333rem",
    "height:before": "0.37333rem",
    "backgroundColor:before": "rgb(0,220,255)",
    "content:before": 0,
    "left:before": "-0.13333rem",
    "top:before": "0.06667rem",
    "borderRadius:before": "0.10667rem"
  },
  "block-flight-special-container-bargin-title-more-margin": {
    "marginLeft": "0.4rem"
  },
  "block-flight-special-container-scene-tip": {
    "paddingBottom": "0.16rem",
    "display": "flex",
    "flexDirection": "row"
  },
  "block-flight-special-container-scene-tip-text": {
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem"
  },
  "block-flight-special-container-scroll-container": {
    "height": "1.53333rem"
  }
};



  module.exports = _styles;
  